// React
import React, { ChangeEvent, useEffect, useState } from "react"
import {
  useParams,
  useSearchParams,
  Link as ReactRouterLink,
  useNavigate,
} from "react-router-dom"

// Hooks and Redux
import { useAppSelector } from "../../../redux/hooks"

// MUI Components
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Checkbox from "@mui/material/Checkbox"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import Grid from "@mui/material/Grid"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select, { SelectChangeEvent } from "@mui/material/Select"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import Autocomplete from "@mui/material/Autocomplete"
import CircularProgress from "@mui/material/CircularProgress"
import Breadcrumbs from "@mui/material/Breadcrumbs"
import Link from "@mui/material/Link"

// MUI Icons
import HomeIcon from "@mui/icons-material/Home"
import PersonIcon from "@mui/icons-material/Person"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import EditIcon from "@mui/icons-material/Edit"

// Utils
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
// import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup"
import Swal from "sweetalert2"
import { ToastContainer, toast } from "react-toastify"
import jwtDecode from "jwt-decode"
import dayjs from "dayjs"

// Styles
import { green } from "@mui/material/colors"

// Services
import {
  sendFilesDocuments,
  deleteDocuments,
} from "../../../services/UserService"
import {
  updateEmploymentContract,
  getEmploymentContractById,
} from "../../../services/EmployeeContractService"
import { getDocumentsfile } from "../../../services/UserService"

// Utils
import { yupResolver } from "@hookform/resolvers/yup"
// import * as yup from "yup"

// Types
import { TokenPayload } from "../../../@types"
import {
  MultipleFileUpload,
  MultipleFileUploadStatusItem,
} from "@patternfly/react-core"
import { fetchDocumentByUser } from "../../../redux/slices/documentsSlice"
import UploadFileIcon from "@mui/icons-material/UploadFile"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import FileContract from "../../users/JobsStatus/FileContract"

import { validateMicrosoftFile } from "../../../utils"

interface readFile {
  fileName: string
  data?: string
  loadResult?: "danger" | "success"
  loadError?: DOMException
}

interface documentFile {
  id: string
  name: string
  type: string
  dmsFileId: string
}

interface IContract {
  nameFile: string
  dmsFileId: string
  name: string
  type: string
  created_by?: string
  modified_by?: string
  is_active?: boolean
  id?: string
}

interface FormData {
  nameFile: string
  active: boolean
  fileContract: any
  // contract?: FileList; // ถ้าใช้ input type="file" ผ่าน react-hook-form
}

const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2MB in bytes

// const EditEmployeeContract: FC<any> = () => {
const EditEmployeeContract = () => {
  // const [searchParams] = useSearchParams()
  // const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const { id } = useParams()

  const userRoleType = useAppSelector((state) => state.user.roletype)
  // const havePermission = userRoleType === "Super Admin"

  const formValidationSchema = yup.object().shape({
    nameFile: yup.string().required(`${t("File Name is required")}`),
    active: yup.boolean().required(),
    fileContract: yup.array().required(),
  })

  const debugBase64 = (base64URL: string) => {
    let win = window.open()
    win?.document.write(
      '<iframe src="' +
        base64URL +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
    )
    return win
  }
  //  const debugBase64 = (base64URL: string) => {

  //  }

  //     const fileId = params.row.dmsFileId
  //     const dataPath = params.row.file.dataPath
  //     const fileName = params.row.file.name || params.row.name
  //     const isMicrosoftFile = validateMicrosoftFile(fileName)

  //     if (fileId && dataPath) {
  //       if (isMicrosoftFile) {
  //         return (
  //           <a href={dataPath} download={fileName}>
  //             {fileName}
  //           </a>
  //         )
  //       } else {
  //         return (
  //           // eslint-disable-next-line jsx-a11y/anchor-is-valid
  //           <a
  //             onClick={() => debugBase64(dataPath)}
  //             style={{ cursor: "pointer" }}
  //           >
  //             {fileName}
  //           </a>
  //         )
  //       }
  //     }

  //     r

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<FormData>({
    resolver: yupResolver(formValidationSchema),
  })
  const navigate = useNavigate()
  // const { data } = props;

  const token = localStorage.getItem("access_token") || ""
  const decoded: TokenPayload = jwtDecode(token)

  const [userFiles, setUserFiles] = useState<File[]>([])
  const [currentFiles, setCurrentFiles] = useState<File[]>([])
  const [readFileData, setReadFileData] = useState<readFile[]>([])
  const [showStatus, setShowStatus] = useState(false)

  const [checkDmsFileId, setCheckDmsFileId] = useState<string>("")

  //   const [statusIcon, setStatusIcon] = useState("inProgress")
  const [documentData, setDocumentData] = useState<IContract[]>([])
  //   const [loading, setLoading] = useState(false)
  const [active, setActive] = useState<boolean>(false)
  const [fileName, setFileName] = useState<string>("")
  const [docName, setDocName] = useState<string>("")
  const [newFileName, setNewFileName] = useState<string>("")
  const [createLoading, setLoadingUpload] = useState<boolean>(false)
  const [statusFile, setStatusFile] = useState<boolean>(false)
  const [dmsFileData, setDmsFileData] = useState<string>("")
  //

  // const { document } = useAppSelector((state) => state.documentDMS)
  // const dispatch = useAppDispatch()
  const UserId = decoded?.UserId ? decoded.UserId : ""
  const usernameToken = decoded?.Username ? decoded.Username : ""

  if (!showStatus && currentFiles.length > 0) {
    setShowStatus(true)
  }

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await dispatch(fetchDocumentByUser())
  //   }
  //   fetchData()
  // }, [dispatch])

  useEffect(() => {
    const fetchEmploymentContract = async () => {
      try {
        const response = await getEmploymentContractById(id)
        if (
          response?.status === 200 &&
          response?.data?.success &&
          response?.data?.data
        ) {
          const data = response?.data?.data
          setValue("nameFile", data.nameFile)
          setValue("active", data.is_active)
          setValue("fileContract", [response?.data?.data])

          setDocumentData([response?.data?.data])
          setActive(data.is_active)
          setFileName(data.nameFile)
          setDocName(data.name)
          setCheckDmsFileId(data.dmsFileId)

          if (data?.dmsFileId) {
            const base64Data = await getDocumentsfile(
              data?.dmsFileId,
              "contract"
            )

            if (base64Data.status === 200) {
              setDmsFileData(base64Data?.data)
              setStatusFile(true)
            }
          }
        }
      } catch (error) {
        console.log(error)
        navigate("/servererror", { replace: true })
      } finally {
        // setLoadingContractList(false)
      }
    }

    fetchEmploymentContract()
  }, [id, navigate])

  const removeFiles = (namesOfFilesToRemove: string[]) => {
    const newCurrentFiles = userFiles.filter(
      (currentFile) =>
        !namesOfFilesToRemove.some((fileName) => fileName === currentFile.name)
    )
    setUserFiles(newCurrentFiles)
    setCurrentFiles(newCurrentFiles)

    const newReadFiles = readFileData.filter(
      (readFile) =>
        !namesOfFilesToRemove.some((fileName) => fileName === readFile.fileName)
    )
    setReadFileData(newReadFiles)
  }

  const handleReadSuccess = (data: string, file: File) => {
    setReadFileData((prevReadFiles) => [
      ...prevReadFiles,
      {
        data,
        fileName: file.name,
        loadResult: "success",
      },
    ])
  }

  const handleReadFail = (error: DOMException, file: File) => {
    setReadFileData((prevReadFiles) => [
      ...prevReadFiles,
      {
        loadError: error,
        fileName: file.name,
        loadResult: "danger",
      },
    ])
  }

  const filterBySize = (file: any) => {
    return file[0].size <= MAX_FILE_SIZE
  }

  const handleFileSelection = (
    e: ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    let files = e.target.files
    let idstokeep = [0, 2]
    if (files) {
      const checkSize = filterBySize(files)

      if (checkSize === true) {
        let droppedFile = Array.prototype.slice
          .call(files)
          .splice(idstokeep[0], idstokeep[1])

        const currentFileNames = userFiles.map((file) => file.name)

        const reUploads = droppedFile.filter((file) => {
          file.typeUpload = type
          setNewFileName(file.name)
          setDocName(file.name)

          return currentFileNames.includes(file.name)
        })

        Promise.resolve()
          .then(() => removeFiles(reUploads.map((file) => file.name)))
          .then(() =>
            setUserFiles((prevFiles) => {
              return [...prevFiles, ...droppedFile]
            })
          )
      } else {
        Swal.fire({
          icon: "error",
          title: `${t("Error")}`,
          text: `${t("text_check_image_hight_2mb")}`,
          confirmButtonText: `${t("ok")}`,
        })
      }
    }
    e.target.value = ""
  }

  const handleActiveChange = (event: ChangeEvent<HTMLInputElement>) => {
    try {
      setActive(event.target.checked)
    } catch (error) {
      navigate("/servererror", { replace: true })
    }
  }

  const onChangeFiles = async () => {
    try {
      const formData = new FormData()
      formData.append("uploadType", "editFiles")
      formData.append("businessPlace", "Betagro")
      formData.append("company", "Betagro")
      formData.append("nameFile", fileName)

      for (let item in userFiles) {
        let type: any = userFiles[item]
        formData.append(type?.typeUpload, userFiles[item])
      }

      if (userFiles && userFiles.length > 0) {
        const resFilesDoc = await sendFilesDocuments(formData, UserId)
        if (resFilesDoc && resFilesDoc.status === 200) {
          setLoadingUpload(false)
          setUserFiles([])
          return resFilesDoc
        } else {
          // setLoadingUpload(false)
          if (resFilesDoc.status === 413) {
            setLoadingUpload(false)
            const currentFile =
              userFiles &&
              userFiles.filter(
                (file) =>
                  file?.type === "image/png" || file?.type === "image/jpg"
              )
            Swal.fire({
              icon: "warning",
              title: `${t("ERROR_MESSAGES.title")}`,
              text: `[${resFilesDoc.status}] ${t(
                "ERROR_MESSAGES.description"
              )}`,
              confirmButtonText: `${t("ok")}`,
            }).then((result) => {
              if (result.isConfirmed) {
                setUserFiles(currentFile)
              }
            })
          } else {
            setLoadingUpload(false)
            const currentFile =
              userFiles &&
              userFiles.filter(
                (file) =>
                  file?.type === "image/png" || file?.type === "image/jpg"
              )
            Swal.fire({
              icon: "warning",
              text: `${t("text_err_400_to_upload_file")} [${
                resFilesDoc.status
              }]`,
              confirmButtonText: `${t("ok")}`,
            }).then((result) => {
              if (result.isConfirmed) {
                setUserFiles(currentFile)
              }
            })
          }
        }
      } else {
        setLoadingUpload(false)
        Swal.fire({
          icon: "warning",
          text: `${t("text_choose_image_before_click_upload")}`,
          confirmButtonText: `${t("ok")}`,
        })
      }
    } catch (error) {
      setLoadingUpload(false)
      Swal.fire({
        icon: "error",
        title: `${t("Oops! Internal Server Error")}`,
        text: `${t("Please try again later.")}`,
        confirmButtonText: `${t("ok")}`,
      }).then(() => {
        setLoadingUpload(false)
      })
      // Handle error
    }
  }

  const onSubmit = async (data: any) => {
    try {
      let respData
      setLoadingUpload(true)

      if (documentData.length > 0) {
        respData = await updateEmploymentContract({
          id: id,
          nameFile: fileName,
          is_active: active,
          typeUpdate: "changeInfo",
          dmsFileId: checkDmsFileId,
          modified_by: usernameToken,
          name: docName,
        })
      } else if (userFiles.length > 0) {
        const respCreateFile = await onChangeFiles()
        if (
          respCreateFile?.status === 200 &&
          respCreateFile?.data?.contractEmpoyment
        ) {
          respData = await updateEmploymentContract({
            id: id,
            nameFile: fileName,
            is_active: active,
            typeUpdate: "changeFile",
            dmsFileId: respCreateFile.data.contractEmpoyment,
            modified_by: usernameToken,
            name: docName,
          })
        }
      } else {
        setLoadingUpload(false)
        Swal.fire({
          icon: "warning",
          text: `${t("text_choose_image_before_click_upload")}`,
          confirmButtonText: `${t("ok")}`,
        })
      }

      if (respData && respData?.data?.status === 200) {
        Swal.fire({
          icon: "success",
          title: `${t("Update status successful!")}`,
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          window.location.assign("/admin/contract/upload")
        })
      } else {
        Swal.fire({
          icon: "error",
          title: `${t("Oops! Internal Server Error")} 1 [${
            respData?.data?.status
          }]`,
          text: `${t("Please try again later.")}`,
          confirmButtonText: `${t("ok")}`,
        }).then(() => {
          setLoadingUpload(false)
        })
      }
    } catch (error) {
      setLoadingUpload(false)
      Swal.fire({
        icon: "error",
        title: `${t("Oops! Internal Server Error")}`,
        text: `${t("Please try again later.")}`,
        confirmButtonText: `${t("ok")}`,
      }).then(() => {
        setLoadingUpload(false)
      })
    }
  }

  const handleStatusFile = (type: string) => {
    return type === "contract" || type === "EMPLOYMENT_CONTRACT"
      ? "text_types_file_contract"
      : ""
  }

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "70px",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: "bold", textAlign: "left" }}>
          {t("edit_btn_EmployeeContract")}
        </Typography>
      </Box>

      <Box
        component="form"
        noValidate
        sx={{ mt: 3 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <TextField
              fullWidth
              required={true}
              id="nameFile"
              label={t("text_nameFile")}
              placeholder={t("text_nameFile")!}
              {...register("nameFile")}
              value={fileName}
              error={errors.nameFile ? true : false}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setFileName(event.target.value)
                setValue("nameFile", event.target.value)
                errors.nameFile = undefined
              }}
            />
            <Typography
              variant="inherit"
              color="error"
              align="left"
              pt={1}
              fontSize={13}
            >
              {errors.nameFile?.message}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <FormControlLabel
              sx={{ paddingTop: 1 }}
              label={t("Active")}
              id="active"
              control={
                <Checkbox
                  checked={active}
                  onChange={handleActiveChange}
                  inputProps={{ "aria-label": "Active" }}
                />
              }
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item lg={3} xs={12} sm={6} md={6}>
            <div
              className={`custom-file-upload ${
                checkDmsFileId.length > 0 || userFiles.length > 0
                  ? "disabled-upload"
                  : ""
              }`}
            >
              <CloudUploadIcon className="upload-icon" />
              {t("text_contract_file_name")}
              <input
                type="file"
                id="contract"
                className="file-input"
                accept=".pdf, .doc,.docx"
                onChange={(event) => {
                  handleFileSelection(event, "contract")
                }}
                disabled={checkDmsFileId.length > 0 || userFiles.length > 0}
              />
            </div>
          </Grid>
          <Grid item lg={6} xs={12} sm={6} md={6}>
            {userFiles.length > 0 && (
              <MultipleFileUpload>
                {userFiles.map((file: any, index: number) => (
                  <div key={index}>
                    <MultipleFileUploadStatusItem
                      id="fileContract"
                      className="file-upload-show"
                      file={file}
                      fileName={`${t(
                        `${handleStatusFile(file.typeUpload)}`
                      )} : ${file.name}`}
                      key={file.name}
                      onClearClick={() => removeFiles([file.name])}
                      onReadSuccess={handleReadSuccess}
                      onReadFail={handleReadFail}
                      fileIcon={<UploadFileIcon color="secondary" />}
                    />
                  </div>
                ))}
              </MultipleFileUpload>
            )}

            {documentData.length > 0 && (
              <MultipleFileUpload>
                {documentData.map((file: any, index: number) => (
                  <div key={`doc-${index}`}>
                    <MultipleFileUploadStatusItem
                      className="file-upload-item"
                      file={file}
                      fileName={`${t(`${handleStatusFile(file?.type)}`)} : ${
                        file?.name
                      }`}
                      key={file?.name}
                      onClearClick={() => {
                        setDocumentData([])
                        setCheckDmsFileId("")
                        setValue("fileContract", [])
                        setStatusFile(false)
                      }}
                      onReadSuccess={handleReadSuccess}
                      onReadFail={handleReadFail}
                      progressValue={100}
                      fileIcon={<UploadFileIcon color="secondary" />}
                    />
                  </div>
                ))}
              </MultipleFileUpload>
            )}
          </Grid>
        </Grid>
        {/* move text_Contact_file_name */}
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={8} xs={8}>
            {statusFile && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "70px",
                }}
              >
                {t("text_Contact_file_name")} :
                <a onClick={() => debugBase64(dmsFileData)}>
                  {t("text_Contact_file_name")}
                </a>
              </Box>
            )}
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={6}>
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ mt: 5, mb: 2, color: "white" }}
              disabled={createLoading}
            >
              {t("ok")}
              {createLoading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    zIndex: 999,
                  }}
                />
              )}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              sx={{ mt: 5, mb: 2 }}
              component={ReactRouterLink}
              to={`/admin/contract/upload `}
            >
              {t("Cancel")}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

export default EditEmployeeContract
